
<owc-input  variant="outlined" rounded 
    placeholder="search" [(ngModel)]="searchValue" (ngModelChange)="applyFilter($event)">
     <owc-icon slot="prefix" name="search" family="outlined"></owc-icon>
     <owc-icon *ngIf="searchValue" slot="suffix" name="close" family="outlined" 
               style="cursor: pointer;" (click)="clearSearch()"></owc-icon>
</owc-input>
